
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("map/map_places",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcenter class=\"flexauto\"><div class=\"content\" style=\"text-align:center;max-width:300px;margin-bottom:48px;\"><img style=\"max-width:160px\" src=\"/images/empty_state_illustration_location_places.svg\"/><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"map.empty.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":434},"end":{"line":1,"column":462}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin\" style=\"color:#888;white-space: normal;\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"map.empty.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":530},"end":{"line":1,"column":557}}})) != null ? stack1 : "")
    + "</p><button style=\"width:fit-content;\" data-fw-onclick=\"addplaceOnClickAction\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"map.empty.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":637},"end":{"line":1,"column":666}}})) != null ? stack1 : "")
    + " </button></div></flexcenter> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol style=\"margin-top:24px;gap:8px;\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"places") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":748},"end":{"line":1,"column":1267}}})) != null ? stack1 : "")
    + " </flexcol> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow class=\"border-pane\" class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"justAdded") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":801},"end":{"line":1,"column":841}}})) != null ? stack1 : "")
    + "\" data-fw-onclick=\"selectplace|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"placeId") : depth0), depth0))
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"picture") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":1,"column":888},"end":{"line":1,"column":1148}}})) != null ? stack1 : "")
    + " <flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"formattedAddress") : stack1), depth0))
    + "</line></flexauto></flexrow> ";
},"5":function(container,depth0,helpers,partials,data) {
    return " animated fadeIn";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\" style=\"width:40px;height:40px;border-radius:50%\"/> ";
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon style=\"width:40px;background-color:var(--bg-selectable);border-radius:50%\"><icon style=\"width:24px;color:var(--fwPrimary)\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "</icon></icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcol class=\"V4 fw-paddingbig-responsive\"><flexrow class=\"h1\"><flexauto>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"map.ourplaces",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":75},"end":{"line":1,"column":101}}})) != null ? stack1 : "")
    + "</flexauto><icon class=\"rounded-border\" data-fw-onclick=\"panerighttoogle\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":175},"end":{"line":1,"column":197}}}))
    + "</icon></flexrow> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"empty") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":215},"end":{"line":1,"column":1286}}})) != null ? stack1 : "")
    + " </flexcol> ";
},"useData":true});
export default TPL;